import { render, staticRenderFns } from "./QMyStatsSubmenu.vue?vue&type=template&id=3a84fc7a&"
import script from "./QMyStatsSubmenu.vue?vue&type=script&lang=js&"
export * from "./QMyStatsSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports